import React, { useState } from 'react';
import { useNavigate } from "react-router-dom";
import {Divider, Typography, Slider, Select } from 'antd';
import {ArrowRightOutlined, PlusOutlined} from "@ant-design/icons";
import { Button, Switch, FormControlLabel } from '@mui/material';
import { ArrowForwardIosSharp } from "@mui/icons-material";
import BlacklistInstance from "../../../Blacklist/components/BlacklistInstance";

const { Option } = Select;

/**
 * Toolbar for managing the aggregated ticker list and settings
 * @param onSubmit - function to handle the submission of the settings
 * @param blacklists - list of blacklists
 * @param screens - list of screens
 * @param config - configuration object
 * @param updateConfig - function to update the configuration object
 * @returns {JSX.Element}
 * @constructor
 */
const AggregateToolbar = ({
                            onSubmit,
                            blacklists,
                            screens,
                            config,
                            updateConfig
}) => {
  const [blaclistDrawerVisible, setBlacklistDrawerVisible] = useState(false);
  const naviagte = useNavigate();

  return (
    <>
        <Button
            style={{width: '100%'}}
            variant={'contained'}
            endIcon={<ArrowForwardIosSharp/>}
            onClick={() => onSubmit()}
          >
            Preview Portfolio
        </Button>
        <Divider/>
        <Select
            showSearch
            style={{ width: '100%' }}
            placeholder="Select a Blacklist"
            optionFilterProp="children"
            onChange={(value)=>updateConfig('blacklist', value)}
            value={config.blacklist}
            filterOption={(input, option) =>
              option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
            }
            suffixIcon={<><span>{blacklists.length}</span><PlusOutlined style={{color: '#029EFF'}} onClick={()=>setBlacklistDrawerVisible(true)}/></>}
        >
          {blacklists.map((blacklist) => (
            <Option key={blacklist.id} value={blacklist.id}>{blacklist.title}</Option>
          ))}
        </Select>
        <Divider className={'borderless'} />
        <Select
                showSearch
                style={{ width: '100%' }}
                placeholder="Select a Screen"
                optionFilterProp="children"
                onChange={(value)=>updateConfig('screener', value)}
                value={config.screener}
                filterOption={(input, option) =>
                  option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                }
                suffixIcon={<><span>{screens.length}</span><ArrowRightOutlined onClick={()=>naviagte('/screener')} style={{color: '#029EFF'}}/></>}
        >
          {screens.map((screen) => (
              <Option key={screen.id} value={screen.id}>{screen.title}</Option>
          ))}
        </Select>
        <Divider className={'borderless'} />
        <FormControlLabel
            control={
            <Switch
                defaultChecked={config.useSubsetInScreen}
                onChange={(value)=>updateConfig('useSubsetInScreen', value)}
            />}
            label={'Screen All Tickers'}/>
        <Divider className={'borderless'}/>
        <Typography.Text>Cutoff Percent: {config.cutoffPercent || 80 }%</Typography.Text>
        <Slider min={50}
                max={100}
                value={config.cutoffPercent || 80}
                onChange={(value)=>{updateConfig('cutoffPercent', value)}}
                step={5}
        />
        <Divider />
        <Typography.Text>Sector Tolerance: {config.sectorTolerance}%</Typography.Text>
        <Slider min={0} max={10} value={config.sectorTolerance} onChange={(value)=>{updateConfig('sectorTolerance', value)}} step={1} />
        <Divider />
        <Typography.Text>Max per Holding: {config.maxPerHolding}%</Typography.Text>
        <Slider min={0} max={25} value={config.maxPerHolding} onChange={(value)=>{updateConfig('maxPerHolding', value)}} step={0.5} />
        <Divider />
      {blaclistDrawerVisible && <BlacklistInstance onClose={()=>setBlacklistDrawerVisible(false)} />}
    </>
  );
};

export default AggregateToolbar;
